import { USER_TYPE, STATION_PERMISSIONS, PERMISSION_TYPE } from "./Constants";

export const isAdmin = (user) => {
    return user.userType === USER_TYPE.ADMIN;
}

export const isTech = (user) => {
    return user.userType === USER_TYPE.TECH;
}

export const isCustomer = (user) => {
    return user.userType === USER_TYPE.CUSTOMER;
}

export const isSuperUser = (user) => {
    return user.superUser;
}

const findPermissions = (type) => {
    return STATION_PERMISSIONS.find((permission) => permission.type === type);
}

export const getStationPermissions = (user) => {

    const { ADMIN, TECH, CUSTOMER } = USER_TYPE;
    const { WRITE, } = PERMISSION_TYPE;
    const { userType, permission, superUser} = user;

    let userPermissions; 

    switch(userType){
        case ADMIN: 
            if(superUser){
                userPermissions = findPermissions("superuser");
            } else {
                userPermissions = findPermissions(userType)
            }
            break;
        case TECH:
            if(permission === WRITE){
                userPermissions = findPermissions(userType);
            } else {
                userPermissions = findPermissions('read');
            }
            break;
        case CUSTOMER:
            if(permission === WRITE){
                userPermissions = findPermissions(userType);
            } else {
                userPermissions = findPermissions('read');
            }
            break;
        default:
            userPermissions = findPermissions('read');
    }
    return userPermissions.permissions;
}

export const getUserPermissions = (user) => {

    const PCI = user.serverType === 'PCI';
    const CLOUD1X = user.serverType === 'cloud1x';
    const isEditable = user.permission === PERMISSION_TYPE.WRITE;

    let restrictedElements = {
        server: {
            pci: PCI, 
            cloud1x: CLOUD1X,
        },
        access: {
            updateManager: PCI && isAdmin(user), 
            accessManagement: isAdmin(user), 
            advancedSearch: (isAdmin(user) || isTech(user)),
        },
        noc: {
            addCustomer: isAdmin(user),
            editCustomer: (isAdmin(user) || isTech(user)) && isEditable, 
            deleteCustomer: isAdmin(user) && isEditable, 
        },
        accessManagement: {
            addTech: isAdmin(user) && isEditable,
            editUser: isAdmin(user) && isEditable,
        },
        station: {
            add: isEditable, 
            edit: isEditable,
            delete: isEditable,
        },
        stationProfile: {
            edit: PCI && isEditable, 
            clear: PCI && isEditable,
        }, 
        device: {
            add: isEditable, 
            edit: isEditable,
            delete: isEditable,
            winbox: PCI && isSuperUser(user), 
            ant: PCI, 
            commander: PCI,
        }
    }

    return Object.freeze(restrictedElements);
}